<script setup lang="ts">
import { computed } from 'vue'

import { useRouteQuery } from '@vueuse/router'

import DeadLetterDetailSheet from '#operations/components/jobs/DeadLetterDetailSheet.vue'
import EnvelopeDetailSheet from '#operations/components/jobs/EnvelopeDetailSheet.vue'
import JobsActive from '#operations/components/jobs/JobsActive.vue'
import JobsDeadLetters from '#operations/components/jobs/JobsDeadLetters.vue'
import JobsOverview from '#operations/components/jobs/JobsOverview.vue'
import PageHeader from '#shared/components/PageHeader.vue'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '#ui/tabs'

definePage({
  meta: { requiresAuth: true, title: 'Jobs' },
})

type Tab = 'overview' | 'active' | 'deadletters'
const TABS: { id: Tab; label: string }[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'active', label: 'Active Jobs' },
  { id: 'deadletters', label: 'Dead Letters' },
]

const tab = useRouteQuery<Tab>('tab', 'overview')

const envelopeId = useRouteQuery<string | null>('envelope', null)
const deadLetterId = useRouteQuery<string | null>('deadLetter', null)

const refetchInterval = computed<number | false>(() =>
  envelopeId.value !== null || deadLetterId.value !== null ? false : 5000,
)
</script>

<template>
  <PageHeader title="Jobs">
    <template #actions>
      <span class="text-xs text-muted-foreground">
        {{
          refetchInterval === false
            ? 'Auto-refresh paused while a message is open'
            : 'Auto-refresh every 5s'
        }}
      </span>
    </template>
  </PageHeader>

  <Tabs v-model="tab">
    <TabsList>
      <TabsTrigger v-for="t in TABS" :key="t.id" :value="t.id">{{ t.label }}</TabsTrigger>
    </TabsList>

    <TabsContent value="overview">
      <JobsOverview :refetch-interval="refetchInterval" />
    </TabsContent>
    <TabsContent value="active">
      <JobsActive :refetch-interval="refetchInterval" />
    </TabsContent>
    <TabsContent value="deadletters">
      <JobsDeadLetters :refetch-interval="refetchInterval" />
    </TabsContent>
  </Tabs>

  <EnvelopeDetailSheet />
  <DeadLetterDetailSheet />
</template>
